import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class Terms {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <section class="fg-card">
                <div class="fg-prose">
                    <p style="margin-bottom: 1.5rem;">Welcome to <strong>footballgirl</strong>. By accessing our website and purchasing our products, you agree to the following terms and conditions.</p>
                    
                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Intellectual Property</h3>
                    <p style="text-align: left; margin-bottom: 1.5rem;">All content on this site, including designs, text, and graphics, is the property of footballgirl and is protected by copyright laws. You may not reproduce or use any content without prior written permission.</p>

                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Product Availability & Description</h3>
                    <p style="text-align: left; margin-bottom: 1.5rem;">Our products are printed on demand. While we strive for accuracy in descriptions and mockups, actual colors and placement may vary slightly. We reserve the right to limit quantities or discontinue products at any time.</p>

                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Limitation of Liability</h3>
                    <p style="text-align: left; margin-bottom: 1.5rem;">footballgirl provides its services on an "as is" basis. We are not liable for any indirect, incidental, or consequential damages arising from the use of our services or the purchase of our products.</p>

                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Governing Law</h3>
                    <p style="text-align: left;">These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which footballgirl is registered. Any disputes will be subject to the exclusive jurisdiction of the courts in that region.</p>
                </div>
            </section>
        `;

        el.innerHTML = sidebarPage({
            title: 'Terms of Service',
            subtitle: 'The legal agreement governing your use of footballgirl',
            main,
            wide: false
        });
        
        // Smooth scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}